import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const getNoticeList = async () => {
  return axios.get(`${BASE_PATH_PORTAL}/data/personas_paziņojums?offset=0&limit=100`).then((response) => response.data)
}
